module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_02_6DD79_1SE_GJI.5a3e92ca.png";